import './showstory.css'
import clousestory from '../../image/close.png'
export default function Showstory({ stories , idstory , showstorybox , storyend , setShowstorybox }) {
    const selectstory = stories.filter(item =>  item.id === idstory)
    function outofstory() {
        setShowstorybox(false)
    }
    return(
        <div className='storybox' style={{
            display: showstorybox === true ? 'block' : 'none'
          }}>
            <div className='storymain' style={{backgroundColor: showstorybox === true ? selectstory[0].colorbanner : 'transparent'}}>
                <img onClick={outofstory} src={clousestory}></img>
                <div className='lineend'>
                    <div className='animationendsrory' style={{width: `${storyend}%`}}></div>
                </div>
                <p style={{color: showstorybox === true ? selectstory[0].colormatn : 'white'}}>{showstorybox === true ? selectstory[0].matn : ''}</p>
            </div>
          </div>
    )
}